// Direct connection to Django backend for Google Forms API
import { authenticatedFetch } from '../utils/authenticatedFetch';

const API_BASE_URL = '/api';

export const googleFormsService = {
  async createForm(accessToken, metadata = {}) {
    try {
      //console.log('🚀 Attempting to create form at:', `${API_BASE_URL}/create-form`);
      //console.log('🔑 Using access token:', accessToken ? 'Token provided' : 'No token');
      //console.log('📊 Metadata:', metadata);
      
      const response = await authenticatedFetch(`${API_BASE_URL}/create-form`, {
        method: 'POST',
        body: JSON.stringify({
          access_token: accessToken,
          metadata: metadata
        })
      });
      
      //console.log('📡 Response status:', response.status);
      //console.log('📡 Response ok:', response.ok);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ API Error Response:', errorText);
        throw new Error(`API request failed with status ${response.status}: ${errorText}`);
      }
      
      const data = await response.json();
      //console.log('✅ Success! Form data:', data);
      return data; // Expected to return {formId, editUrl}
    } catch (error) {
      console.error('💥 Full error details:', error);
      console.error('💥 Error message:', error.message);
      console.error('💥 Error stack:', error.stack);
      throw error;
    }
  },

  async getActiveSurveys(school) {
    try {
      //console.log('📊 Fetching active surveys...');

      const response = await authenticatedFetch(`${API_BASE_URL}/get-active-surveys`, {
        method: 'POST',
        body: JSON.stringify({
          school: school
        })
      });
      
      if (!response.ok) {
        throw new Error(`Failed to fetch surveys: ${response.status}`);
      }
      
      const data = await response.json();
      //console.log('✅ Surveys fetched:', data);
      return data;
    } catch (error) {
      console.error('❌ Error fetching surveys:', error);
      throw error;
    }
  }
}; 